import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ZapIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-39">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col items-start" data-id="element-41">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-sage/10 text-brand-sage font-semibold text-sm mb-6" data-id="element-42">
            <BookOpenIcon className="w-4 h-4" data-id="element-43" />
            <span data-id="element-44">Digital E-book • Instant Download</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-45">
            Discover How to Entertain and Educate Your Kids with{' '}
            <span className="text-brand-terracotta italic" data-id="element-46">
              50 Creative Activities
            </span>
          </h1>

          <p className="text-lg md:text-xl text-brand-gray-warm mb-8 leading-relaxed max-w-lg" data-id="element-47">
            Practical solutions for kids ages 3 to 6. Simple instructions,
            easy-to-find materials, and guaranteed fun.
          </p>

          <div className="w-full sm:w-auto flex flex-col items-center sm:items-start gap-3" data-id="element-48">
            <a href="#download" className="w-full sm:w-auto px-8 py-4 bg-brand-peach hover:bg-brand-peach-hover text-white rounded-full font-bold text-lg shadow-soft hover:shadow-soft-lg transition-all duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-brand-peach/30 inline-block text-center" onClick={e => {
            e.preventDefault();
            document.getElementById('download')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-49">
              Buy Now — $6.35 USD
            </a>
            <div className="flex items-center gap-1.5 text-sm text-brand-gray-warm/80 font-medium" data-id="element-50">
              <ZapIcon className="w-4 h-4 text-amber-500" data-id="element-51" />
              <span data-id="element-52">Instant PDF download</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative" data-id="element-53">
          {/* Decorative background blob */}
          <div className="absolute inset-0 bg-brand-sage/20 rounded-full blur-3xl transform scale-90 -z-10" data-id="element-54"></div>

          <img src="https://cdn.magicpatterns.com/uploads/8HDao3AsVxuxmJQSgVXPPS/imagen.png" alt="E-book preview on a tablet showing the 50 activities" className="w-full h-auto rounded-2xl shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-55" />
        </motion.div>
      </div>
    </section>;
}